<template>
<!--我的积分-->
  <div id="personpoint">
    <h2 class="title">
      <a href="" class="prev"></a>
      我的积分
      <a href="" class="rule">积分规则</a>
    </h2>
    <h3 class="point">
      8874
    </h3>
    <div class="note">
      <h6>小积分、大用处</h6>
      <p>积分可以在活动课程里面兑换课程哦</p>
    </div>
    <!--充值记录-->
    <div class="record">
      <h5>会员权益</h5>
      <ul class="main">
        <li>
          <div class="left">
            <b>线上充值</b>
            <i>2022-07-23 15:50:40</i>
          </div>
          <div class="right">+70</div>
        </li>
        <li>
          <div class="left">
            <b>线上充值</b>
            <i>2022-07-23 15:50:40</i>
          </div>
          <div class="right">+70</div>
        </li>
        <li>
          <div class="left">
            <b>线上充值</b>
            <i>2022-07-23 15:50:40</i>
          </div>
          <div class="right">+70</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonPoint'
}
</script>

<style scoped lang="stylus">
  #personpoint
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: #1E81F2
      padding: .14rem .16rem
      font-size: .32rem
      color: #fff
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #fff
          border-bottom: .03rem solid #fff
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      a.rule
        position: absolute
        top: .1rem
        right: .32rem
        font-size: .26rem
        color: #fff
        font-weight: 500
    h3.point
      background-color: #1E81F2
      padding: .48rem .4rem
      font-size: .72rem
      color: #fff
    .note
      width: 7.5rem
      height: 1.32rem
      padding: 0 .4rem
      background-color: #1E81F2
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h6
        font-size: .32rem
        color: rgba(255, 255, 255, .7625)
      p
        margin-top: .08rem
        font-size: .22rem
        color: rgba(255, 255, 255, .7625)
    .record
      h5
        line-height: 1.06rem
        padding: 0 .4rem
        border-bottom: .02rem solid #E7E8E9
        font-size: .32rem
        color: #333
        font-weight: 600
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
      ul.main
        li
          display: flex
          justify-content: space-between
          align-items: center
          height: 1.42rem
          border-bottom: .02rem solid #E7E8E9
          padding: 0 .4rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          b
            display: block
            font-size: .32rem
            color: #333
          i
            display: block
            margin-top: .04rem
            font-size: .24rem
            color: #A3A9B7
          .right
            font-size: .32rem
            color: #333
            font-weight: 600
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonPoint.vue